import { useMemo } from 'react'

import { useLinkTo } from '@react-navigation/native'
import { Product, useGetProductsMost } from 'integration/resources/products'
import { Box, Button, Pressable, Skeleton, Text, VStack } from 'native-base'

type ProductsTrendingDesktopProps = {
  searchTerm?: string
  isError: boolean
  handleProductClick: (productName: string) => void
}

export const ProductsTrendingDesktop = ({
  searchTerm,
  handleProductClick,
  isError
}: ProductsTrendingDesktopProps) => {
  const linkTo = useLinkTo()

  const { data, isLoading } = useGetProductsMost()

  const fiveProducts: Product[] = useMemo(() => (data?.data ?? []) as Product[], [data])

  const fiveMostPurchasedItems = fiveProducts.map((product) => product)

  return (
    <VStack
      width={searchTerm ? '' : '100%'}
      maxHeight="560px"
      borderBottomLeftRadius={8}
      borderBottomRightRadius={8}
      justifyContent="space-between">
      <VStack display="flex" width={searchTerm ? '214px' : '100%'}>
        {isLoading && fiveProducts ? (
          <Box padding="16px">
            <Skeleton width={47} pb={2} />
          </Box>
        ) : (
          <>
            <Text padding="16px" fontWeight="bold" fontSize={18} color="gray.900">
              Produtos em alta
            </Text>

            {fiveMostPurchasedItems.slice(0, 5).map((product, index) => (
              <Pressable
                display="flex"
                justifyContent="center"
                width={searchTerm ? '214px' : '100%'}
                height="56px"
                borderBottomColor={
                  index === fiveMostPurchasedItems.length - 1 && !searchTerm
                    ? 'transparent'
                    : 'gray.100'
                }
                borderBottomWidth="1px"
                _hover={{
                  backgroundColor: 'gray.150'
                }}
                key={product.id}
                onPress={() => handleProductClick(product.name)}>
                <Text
                  fontSize={16}
                  //@ts-ignore
                  cursor="pointer"
                  padding="16px"
                  color="gray.600">
                  {product.name}
                </Text>
              </Pressable>
            ))}
          </>
        )}
      </VStack>

      {searchTerm && !isError && (
        <Button
          variant="outline"
          onPress={() => linkTo(`/produtos/todos`)}
          borderWidth="1px"
          width="100%"
          height="40px"
          maxWidth="183px"
          marginRight={-8}
          borderRadius={30}
          display="flex"
          mb={5}
          ml={4}>
          Ver todos os produtos
        </Button>
      )}
    </VStack>
  )
}
